export const findCategoryById = (categories, id) => categories?.find(item => item.id === parseInt(id, 10))

export const getFirstMapType = arr => arr?.maps?.maps?.[0]

export const getPageData = page => page?.data

export const getInstanceIdByPage = page => page?.[0]?.idinstancia
